import * as React from 'react';
import { useState, useEffect, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { AuthContext } from "../Auth/AuthContext";

export default function RequestDialog({ setOpen, open, processing_requests }) {
  const { t } = useTranslation();
  const { jwt } = useContext(AuthContext);

  // Create a local state from the prop to control the checkbox UI
  const [localRequests, setLocalRequests] = useState([]);

  // When the prop changes, update local state
  useEffect(() => {
    setLocalRequests(processing_requests);
  }, [processing_requests]);

  const handleClose = () => {
    setOpen(false);
  };

  // Update the "done" field in Strapi and in the local state
  const handleChange = async (event) => {
    const reqId = event.target.name; // checkbox name holds the processing request id
    const newDone = event.target.checked;
    try {
      await axios.put(
        `${global.API_URL}/api/processing-requests/${reqId}`,
        { data: { done: newDone } },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      // Update local state so that the checkbox reflects the new state
      setLocalRequests(prevRequests =>
        prevRequests.map(req =>
          req.id.toString() === reqId ? { ...req, done: newDone } : req
        )
      );
    } catch (err) {
      console.error("Error updating processing request", err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Box sx={{ p: 3 }}>
        <DialogTitle>
          <Typography variant="h3" component="div">
            {t("Requests")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <FormGroup>
              {localRequests.map((req, index) => (
                <React.Fragment key={index}>
                  <Divider sx={{ borderColor: "text.secondary" }} />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={req.id.toString()}
                        checked={req.done}
                        onChange={handleChange}
                      />
                    }
                    label={t(req.processing.title)}
                  />
                  {req.subprocessings.length > 0 && (
                    <Box sx={{ pl: 4, pb: 2 }}>
                      <Typography color="text.secondary" variant="body1">
                        {t("Options")}
                      </Typography>
                      {req.subprocessings.map((sub, subIndex) => (
                        <Typography
                          key={subIndex}
                          color="text.secondary"
                          variant="body2"
                        >
                          {t(sub.title)}
                        </Typography>
                      ))}
                    </Box>
                  )}
                </React.Fragment>
              ))}
            </FormGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {t("OK")}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
